import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { useState, useLayoutEffect } from 'react';
import { BsPlusSquare } from '@react-icons/all-files/bs/BsPlusSquare';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import '../../components/Canvas/Canvas.style.js';
import '../../components/Canvas/PreviewModeContainer.js';
import '../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../components/FieldItem.js';
import '../../components/FormGroup/FormGroup.js';
import '../../components/FormGroup/LogDataFormGroup.js';
import '../../components/Header/index.js';
import '../../components/Input/ColorPickerField/index.js';
import '../../components/Input/URLInput.js';
import '../../components/Inspector/Inspector.js';
import '../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import { useEditorNode } from '../../hooks/useEditorNode.js';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import { useImpressionLog } from '../../hooks/useImpressionLog.js';
import 'react-dom';
import '../../components/Tooltip/Tooltip.js';
import '../../components/Toolbar/Toolbar.style.js';
import '../../components/TreeList/Draggable.js';
import { EditorPlaceholder } from '../../components/EditorPlaceholder/EditorPlaceholder.js';
import '../../components/FormContent.js';
import compareAsc from '../../node_modules/date-fns/esm/compareAsc/index.js';

var _excluded = ["children", "duration", "path", "logData"];
function Block(_ref) {
  var children = _ref.children,
    duration = _ref.duration,
    path = _ref.path,
    logData = _ref.logData,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    onDuration = _useState2[0],
    setOnDuration = _useState2[1];
  var _useEditorNode = useEditorNode(path),
    displayMode = _useEditorNode.displayMode,
    displayDate = _useEditorNode.displayDate;
  var _useImpressionLog = useImpressionLog({
      logData: logData,
      disable: displayMode === 'edit'
    }),
    ref = _useImpressionLog.ref;
  useLayoutEffect(function () {
    if (!duration) {
      return setOnDuration(true);
    }
    var interval;
    var compareDisplayDateToDuration = function compareDisplayDateToDuration() {
      var currentDate = displayDate !== null && displayDate !== void 0 ? displayDate : new Date();
      if (duration.startAt) {
        var beforeStart = compareAsc(currentDate, new Date(duration.startAt)) < 0;
        if (beforeStart) {
          return setOnDuration(false);
        }
      }
      if (duration.endAt) {
        var beforeEnd = compareAsc(currentDate, new Date(duration.endAt)) < 0;
        if (beforeEnd) {
          return setOnDuration(true);
        }
        setOnDuration(false);
        clearInterval(interval);
        return;
      }
      setOnDuration(true);
      clearInterval(interval);
    };
    compareDisplayDateToDuration();
    interval = window.setInterval(compareDisplayDateToDuration, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [duration === null || duration === void 0 ? void 0 : duration.startAt, duration === null || duration === void 0 ? void 0 : duration.endAt, displayDate]);
  if (!onDuration && displayMode !== 'edit') {
    return null;
  }
  return jsx(Box, _extends({
    ref: ref
  }, props), children || jsx(EditorPlaceholder, {
    icon: jsx(BsPlusSquare, null),
    message: "\uC544\uC774\uD15C\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694."
  }));
}
var Box = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1iuqyl50"
} : {
  target: "e1iuqyl50",
  label: "Box"
})("margin:", function (_ref2) {
  var margin = _ref2.margin;
  return margin ? "".concat(margin.top, "px ").concat(margin.right, "px ").concat(margin.bottom, "px ").concat(margin.left, "px") : 0;
}, ";padding:", function (_ref3) {
  var padding = _ref3.padding;
  return padding ? "".concat(padding.top, "px ").concat(padding.right, "px ").concat(padding.bottom, "px ").concat(padding.left, "px") : 0;
}, ";border:", function (_ref4) {
  var border = _ref4.border;
  return border ? "".concat(border.width, "px solid ").concat(border.color) : 'none';
}, ";border-radius:", function (_ref5) {
  var border = _ref5.border;
  return border ? "".concat(border.radius, "px") : 0;
}, ";background:", function (_ref6) {
  var background = _ref6.background;
  return background || 'none';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export { Block };
//# sourceMappingURL=Block.js.map
